import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import uuid from "react-uuid";
import client from "../../images/client.png";
import website from "../../images/web.png";
const ProjectDetails = () => {
  const { projectId } = useParams();

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  const filterProject = projects.filter((project) => project.id == projectId);

  var settings = {
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="project-details-page">
      <div className="project-details">
        {filterProject.map((project) => (
          <div key={uuid()} className="project-item">
            <div className="name-links">
              <h2>{project.name}</h2>
              <div className="links">
                <span>Project Links</span>
                <ul>
                  <li title="Live site">
                    <a href={project.livesite} target="_blank">
                      {" "}
                      <img src={website} alt="" />{" "}
                    </a>
                  </li>
                  {project?.clientGithub?.length > 0 && (
                    <li title="Github Client">
                      <a href={project.clientGithub} target="_blank">
                        {" "}
                        <img src={client} alt="" />{" "}
                      </a>
                    </li>
                  )}

                  {project?.serverGithub?.length > 0 && (
                    <li title="Github Server">
                      <a href={project.serverGithub} target="_blank">
                        {" "}
                        <img src={client} alt="" />{" "}
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="slider">
              <Slider {...settings}>
                {project.images.map((image) => (
                  <div key={uuid()}>
                    <img className="slider-image" src={image} alt="" />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="features-tech">
              <div className="technology">
                <h6>Technology</h6>
                <ul>
                  {project.tech.map((singleTech) => (
                    <li key={uuid()}> {singleTech}</li>
                  ))}
                </ul>
              </div>

              <div className="features">
                <h6>Features</h6>

                <ul>
                  {project.features.map((singlefeature) => (
                    <li key={uuid()}> - {singlefeature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectDetails;
